<template>
  <section
    class="zesa-buy-form mt-5"
    v-if="showBuyZESAForm"
    @zesapurchasecancelled="showTheZESAForm"
  >
    <div class="columns">
      <div class="column"></div>
      <div class="column mb-5 has-background-link-light">
        <h3 class="title is-5">
          Fill in your details to complete the purchase
        </h3>
        <div class="form-fields has-text-centered">
          <div class="field">
            <p class="control has-icons-left has-icons-right">
              <input
                class="input"
                type="number"
                placeholder="ZESA Meter Number"
                v-model="zesaMeterNumber"
              />
              <span class="icon is-small is-left">
                <i class="fas fa-calculator"></i>
              </span>
            </p>
            <p class="has-text-danger" v-if="zesaMeterNumberError">
              {{ zesaMeterNumberError }}
            </p>
          </div>
          <div class="field">
            <p class="control has-icons-left">
              <input
                v-model="zesaTokenPhone"
                class="input"
                type="number"
                placeholder="Phone number to send token to"
              />
              <span class="icon is-small is-left">
                <i class="fab fa-whatsapp"></i>
              </span>
            </p>
            <p class="has-text-danger" v-if="zesaTokenPhoneError">
              {{ zesaTokenPhoneError }}
            </p>
          </div>
          <div class="field">
            <p class="control has-icons-left">
              <input
                class="input"
                type="text"
                placeholder="Your Email"
                v-model="zesaEmail"
              />
              <span class="icon is-small is-left">
                <i class="fas fa-envelope"></i>
              </span>
            </p>
            <p class="has-text-danger" v-if="zesaEmailError">
              {{ zesaEmailError }}
            </p>
          </div>
        </div>
        <div class="subtitle is-6 has-text-centered my-5">
          You are buying a ${{ zesaunits }} ZWL ZESA Token
        </div>
        <div class="field title is-5 has-text-centered">Pay for your order</div>
        <div class="columns has-text-centered">
          <div class="column">
            <div class="field">
              <p class="subtitle mb-2">Pay Using PayPal</p>
              <p class="is-italic my-3">
                You will Pay<span>US${{ zesaUSDAmount }}</span>
              </p>
              <p class="control">            
                <div  @click="processPayPal" class="wp-block-button has-custom-width wp-block-button__width-25"><a class="wp-block-button__link has-white-color has-vivid-cyan-blue-background-color has-text-color has-background wp-element-button"><strong>Paypal</strong></a></div>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="column"></div>
    </div>
  </section>
  <ZESAConfirm
    @zesapurchasecancelled="showTheZESAForm"
    :zesaZARAmount="zesaZARAmount"
    :zesaUSDAmount="zesaUSDAmount"
    :zesaunits="zesaunits"
    :chosenPAmount="chosenPAmount"
    :chosenPMethod="chosenPMethod"
    :meterDetails="meterDetails"
    :showLoading="showLoading"
    :showConfirm="showConfirm"
    :zesaEmail="zesaEmail"
    :zesaTokenPhone="zesaTokenPhone"
    @brokenarrow="sayBrokenArrow"
    @hideconfirmbox="hideZESAConfirm"
    @hidespinner="hideShowLoading"
    @showspinner="doShowSpinner"
  />
</template>

<script>
import ZESAConfirm from "./ZESAConfirm.vue";
export default {
  name: "BuyZESAForm",
  props: ["zesaZARAmount", "zesaUSDAmount", "zesaunits", "showBuyZESAForm"],
  components: {
    ZESAConfirm,
  },
  emits: ["brokenarrow", "hidezesaform", "showzesabuyform"],
  data() {
    return {
      zesaEmail: null,
      zesaEmailError: null,
      zesaTokenPhone: null,
      zesaTokenPhoneError: null,
      chosenPMethod: null,
      chosenPAmount: null,
      meterDetails: null, //Object from HotRecharge Contains both number and Address
      zesaMeterNumber: null, //ZESA meter number entered by customer
      zesaMeterNumberError: null,
      showLoading: false,
      showConfirm: false,
    };
  },
  methods: {
    showTheZESAForm() {
      this.showConfirm = false;
      this.$emit("showzesabuyform");
    },
    hideBuyZESAForm() {
      this.$emit("hidezesaform");
    },
    processPayPal() {
      if (!this.validateInputFields()) {
        return;
      }
      this.hideBuyZESAForm();
      this.showLoading = true;
      this.chosenPMethod = "paypal";
      this.chosenPAmount = this.zesaUSDAmount;
      //Check that we have a valid meter number here
      if (this.zesaMeterNumber === "" || this.zesaMeterNumber === null) {
        //Some error here
      } else if (true) {
        //Call validation regex on meter number
      } else {
      }
      this.getCustomerDetails();
    },
    processPayFast() {
      if (!this.validateInputFields()) {
        return;
      }
      this.hideBuyZESAForm();
      this.showLoading = true;
      this.chosenPMethod = "payfast";
      this.chosenPAmount = this.zesaZARAmount;
      //Check that we have a valid meter number here
      if (this.zesaMeterNumber === "" || this.zesaMeterNumber === null) {
        //Some error here
      } else if (true) {
        //Call validation regex on meter number
      } else {
      }
      this.getCustomerDetails();
    },
    getCustomerDetails() {
      const nobodyCares = fetch(
        "https://zimpricecheck.com/wp-json/zimpricecheck-bill-payments/1.0.0/zesa/get-customer-details",
        {
          method: "POST", // or 'PUT'
          mode: "cors",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email: this.zesaEmail,
            whatsapp_number: this.zesaTokenPhone,
            payment_method: this.chosenPMethod, //set when button is clicked
            amount: this.zesaunits,
            bill_type: "zesa", //We can hard code this as this is only ever going to be ZESA
            meter_number: this.zesaMeterNumber,
          }),
        }
      )
        .then((res) => res.json())
        .then((data) => {
          this.meterDetails = data;
          this.showLoading = false;
          this.showConfirm = true;
        })
        .catch((error) => {
          console.log("Error:", error);
        });
    },
    sayBrokenArrow() {
      this.$emit("brokenarrow");
    },
    hideZESAConfirm() {
      this.showConfirm = false;
    },
    hideShowLoading() {
      this.showLoading = false;
    },
    doShowSpinner() {
      this.showLoading = true;
    },
    validateInputFields() {
      //check meter number first
      if (!this.zesaMeterNumber) {
        this.zesaMeterNumberError = "You need to enter the meter number";
        return false;
      }

      const pattern = new RegExp("^[0-9]{11}$");
      if (!pattern.test(this.zesaMeterNumber)) {
        this.zesaMeterNumberError = "Invalid meter number please try again";
        return false;
      } else {
        this.zesaMeterNumberError = null;
      }
      //Check phone number
      if (!this.zesaTokenPhone) {
        this.zesaTokenPhoneError =
          "We need a phone number to send the token to.";
        return false;
      }
      if (
        !String(this.zesaTokenPhone).match(/^(?:0?(?:77|78|71|73))\d{7}$/gis)
      ) {
        this.zesaTokenPhoneError =
          "For ZESA the phone number has to be Zimbabwean";
        return false;
      } else {
        this.zesaTokenPhoneError = null;
      }
      //Check email
      const re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!this.zesaEmail) {
        this.zesaEmailError = "You need to enter an email address";
        return false;
      }
      if (!re.test(this.zesaEmail.toLowerCase())) {
        this.zesaEmailError =
          "The email address you entered is not valid please try again";

        return false;
      } else {
        this.zesaEmailError = null;
      }
      //Return true if and only if all checks pass
      return true;
    },
  },
};
</script>

<style scoped>
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}
</style>
